/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import { constants } from '../utils/Constants';
import { debugLog } from '../utils/debug';

export const SyncAttachments = (accessToken, attachment, message_id, callback) => {
    if (accessToken && attachment != undefined && message_id != undefined) {
        debugLog("SyncAttachments.jsx, Line No: 09, attachments", attachment);
        const byteCharacters = atob(attachment.base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: attachment.contentType });

        const myHeaders = new Headers();
        myHeaders.append("Authorization", `JWT ${accessToken}`);

        const formdata = new FormData();
        formdata.append("file", blob, attachment.name);
        formdata.append("message_id", message_id);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        fetch(`${constants.BASE_URL}/api/v1/email/sync/attachments/`, requestOptions)
            .then(response => response.text())
            .then(result => {
                callback(null, result);
            })
            .catch(error => {
                callback(error, null);
            });
    } else {
        debugLog("SyncAttachments.jsx, Line No: 42,", "SyncAttachments API not call due to undefined attachments parameter");
    }
}
